<ul [ngClass]="['page-links', resourcesCssService.responsiveClass(), navigationClass()]">
  <div [hidden]='!shouldShowResourceLinks()'>
      <button (click)='commands.gotoVideoLibraryPage()'>Video Library</button>
      <button (click)='commands.gotoParentEducationPage()'>PEM Library</button>
      <button (click)='commands.gotoTeacherNotesPage()'>Teacher Blog</button>
      <button (click)='commands.gotoTeachingToolsPage()'>Teaching Tools</button>
      <button (click)='commands.gotoTrainingPage()'>Trainings/Workshops</button>
  </div>
  <li *ngFor='let page of pages;'>
    <button [ngClass]='{"selected": isCurrentPage(page.slug), "nested": isChildPage(page), "title": !isChildPage(page)}' (click)='commands.gotoPagesPage(null, page)'>{{page.title}}</button>
    <app-pages-navigation *ngIf='page.pages.length > 0 && this.showChildren' [pages]=page.pages [topLevel]=false></app-pages-navigation>
  </li>
</ul>